import { SocialMediaAccountPublic } from '@/lib/api';
import { PlatformBadge } from './PlatformBadge';
import { Button } from '@/components/ui/button';
import { AlertCircle, CheckCircle, Trash2 } from 'lucide-react';

interface AccountCardProps {
  account: SocialMediaAccountPublic;
  onDisconnect: (accountId: string) => void;
}

export function AccountCard({ account, onDisconnect }: AccountCardProps) {
  const isActive = account.status === 'active';

  return (
    <div className="flex items-center justify-between p-4 border rounded-lg bg-card">
      <div className="flex items-center gap-3">
        {account.platformAvatarUrl ? (
          <img
            src={account.platformAvatarUrl}
            alt={account.platformName ?? account.platform}
            className="w-10 h-10 rounded-full"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center text-muted-foreground text-sm font-bold">
            {(account.platformName ?? account.platform)[0].toUpperCase()}
          </div>
        )}
        <div>
          <div className="flex items-center gap-2">
            <span className="font-medium text-sm">
              {account.platformName ?? account.platformUsername ?? account.platformUserId}
            </span>
            {isActive ? (
              <CheckCircle className="h-4 w-4 text-green-500" />
            ) : (
              <AlertCircle className="h-4 w-4 text-destructive" />
            )}
          </div>
          <div className="flex items-center gap-2 mt-1">
            <PlatformBadge platform={account.platform} />
            {account.platformUsername && (
              <span className="text-xs text-muted-foreground">@{account.platformUsername}</span>
            )}
          </div>
          {account.lastError && (
            <p className="text-xs text-destructive mt-1">{account.lastError}</p>
          )}
        </div>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onDisconnect(account.accountId)}
        className="text-muted-foreground hover:text-destructive"
      >
        <Trash2 className="h-4 w-4" />
        <span className="sr-only">Disconnect</span>
      </Button>
    </div>
  );
}
